module.exports = __webpack_public_path__ + "static/media/gu.beb28cdd.svg";